import React from 'react';
export function TimeCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.21 14.8c-.2.29-.51.45-.84.45-.19 0-.38-.05-.55-.17l-3.37-2.25A.995.995 0 0111 12V7.5c0-.55.45-1 1-1s1 .45 1 1v3.96l2.93 1.96c.46.3.58.93.28 1.38zM12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2z"
  }));
}